import React, { useState } from "react";
import { Popover } from "antd";

const COLOR_BACKGROUND = {
  unmarked: "#1a1a1a",
  red: "#ffa1a1",
  yellow: "#ffffa1",
  green: "#a8ffa1",
};

const OPTIONS = ["red", "yellow", "green"];

// Bolinha clicável de status de estudo (preta+"?" = não marcado). Clique
// abre um mini seletor inline (vermelho/amarelo/verde) — reaproveita a
// mesma paleta do popover antigo (modal-revision-color.js), mas como
// componente próprio, sem depender da cadeia de modais antiga.
const RevisionColorDot = ({ color = "unmarked", onSelect, disabled }) => {
  const [open, setOpen] = useState(false);

  const handlePick = (newColor) => {
    setOpen(false);
    if (newColor !== color) onSelect(newColor);
  };

  return (
    <Popover
      trigger="click"
      open={open && !disabled}
      onOpenChange={(next) => !disabled && setOpen(next)}
      content={
        <div className="revision-color-options">
          {OPTIONS.map((opt) => (
            <button
              key={opt}
              type="button"
              title={opt}
              className={`revision-color-swatch revision-color-swatch-${opt}`}
              onClick={() => handlePick(opt)}
            />
          ))}
        </div>
      }
    >
      <button
        type="button"
        disabled={disabled}
        className="revision-color-dot"
        style={{ backgroundColor: COLOR_BACKGROUND[color] || COLOR_BACKGROUND.unmarked }}
      >
        {color === "unmarked" && <span>?</span>}
      </button>
    </Popover>
  );
};

export default RevisionColorDot;
